<template>
  <div class="content">
    <!-- 顶部标题区域 -->
    <div class="top-banner">
      <img src="../../../assets/webActivity/couponPack/bg_top.png" alt="" class="bg-top" />
    </div>

    <!-- 购买记录 -->
    <div class="ico-record">
      <div @click="goRule" class="rule"></div>
      <div @click="goRecord" class="record"></div>
    </div>

    <!-- 时间段选择区域 -->
    <div class="time-slots" ref="timeSlotsContainer">
      <div
        v-for="(slot, index) in state.timeSlots"
        :key="index"
        :ref="el => { if (el) timeSlotRefs[index] = el }"
        :class="['time-slot', { active: slot.isActive }]"
        @click="selectTimeSlot(index)"
      >
        <div v-if="slot.status == 1" class="countdown" :class="{active: slot.isActive}">
          <div class="countdown-text">
            <span v-if="slot.h" class="frame">{{ slot.h }}</span>
            <span v-if="slot.h" class="mao">:</span>
            <span v-if="slot.m" class="frame">{{ slot.m }}</span>
            <span v-if="slot.m" class="mao">:</span>
            <span v-if="slot.s" class="frame">{{ slot.s }}</span>
          </div>
          <span class="lable">{{ slot.name }}</span>
        </div>
        <div v-else class="time-label" :class="{active: slot.isActive}">
          <span>{{ slot.name }}</span>
          <span>{{ slot.status == 0 ? `已结束`:`即将开始` }}</span>
        </div>
      </div>
    </div>

    <!-- 可用游戏列表 -->
    <div class="support-container" @click="viewGameList">
      <img src="../../../assets/webActivity/couponPack/ico_tip.png" alt="">
      <span>适用于大部分0.1/0.05折游戏，查看可用游戏名单</span>
      <img src="../../../assets/webActivity/couponPack/ico_arrow.png" alt="">
    </div>

    <!-- 优惠券卡片区域 -->
    <div class="coupon-cards">
      <!-- 加载动画 -->
      <div v-if="state.loading" class="loading-container">
        <van-loading color="#8E6126" size="24px" vertical>
        </van-loading>
      </div>
      
      <!-- 空状态 -->
      <div v-else-if="!state.loading && state.couponCards.length === 0" class="empty-container">
        <div class="empty-content">
          <!-- <img src="../../../assets/personal/empty_img.png" class="empty-icon"/> -->
          <div class="empty-text">暂无特惠包</div>
        </div>
      </div>
      
      <!-- 优惠券卡片列表 -->
      <template v-if="!state.loading && state.couponCards.length > 0">
        <div
          v-for="(card, index) in state.couponCards"
          :key="index"
          class="coupon-card"
          @click="showCouponPopup(card)"
        >

                <!-- 补贴标签 -->
        <div class="subsidy-tag" :class="{xianliang: card.tags != ''}">
          <span>补贴{{ formatDecimal(card.subsidy_rate) }}%</span>
        </div>
        <div class="card-content">
          <!-- 优惠券信息 -->
          <div class="coupon-info">
            <div class="total-amount">
              <div class="box">
                <span>¥</span>
                <span class="amount">{{ formatDecimal(card.total_coupon_money) }}</span>
              </div>
            </div>
            <div v-if="card.coupons" class="coupon-count">
              分{{ card.total_coupon_num }}张优惠券
              <img src="../../../assets/webActivity/couponPack/ico_arrow.png" alt="" class="arrow-icon" />
            </div>
          </div>

          <!-- 余额 -->
          <div class="gift-balance">
            <img src="../../../assets/webActivity/couponPack/ico_jb.png" alt="" class="coin-icon" />
            <span>{{ formatDecimal(card.give_money) }}余额</span>
          </div>

          <!-- 特殊标签 -->
           <div class="tag-box">
              <div class="zhe" v-if="card.discount_rules_text">
                <span class="tag-icon">折</span>
                <span class="van-ellipsis" >{{ card.discount_rules_text }}</span>
              </div>

              <div class="special-tag" v-if="card.tags">
                <img src="../../../assets/webActivity/couponPack/ico_time.png" alt="" class="tag-icon" />
                <span class="van-ellipsis" >{{ card.tags }}</span>
              </div>
           </div>


          <!-- 价格信息 -->
          <div class="price-box">
            <div class="price-info">
              <div class="current-price">
                <span>¥</span>
                <span>{{ formatDecimal(card.actual_amount) }}</span>
              </div>
        
              <span v-if="card.money" class="original-price">¥{{ formatDecimal(card.money) }}</span>
            </div>

            <div class="" :class="card.purchase_status == 1 ? `buy-btn` : `buy-btn2`" @click.stop="handleBuy(card)">
              <span>{{ card.purchase_text }}</span>
            </div>
          </div>

        </div>
        </div>
      </template>
    </div>

    <!-- 底部规则说明区域 -->
    <div class="rules-section" ref="rulesSection">
      <!-- 查看不可用游戏名单 -->
      <!-- <div class="game-list-link" @click="viewGameList">
        <img src="../../../assets/webActivity/couponPack/ico_tip.png" alt="" class="tip-icon" />
        <span>查看余额不可用游戏名单</span>
        <img src="../../../assets/webActivity/couponPack/ico_arrow.png" alt="" class="arrow-icon" />
      </div> -->

      <!-- 规则说明 -->
      <div class="rules-content">
        <img src="../../../assets/webActivity/couponPack/rule2.png" alt="" class="rule-image" />
      </div>
    </div>
  </div>
  

  <CouponPackSupportGamePopup v-model:show-game="state.showGame"></CouponPackSupportGamePopup>

  <!-- 优惠券详情弹框 -->
  <van-popup
    v-model:show="state.showCouponPopup"
    round
    position="bottom"
    @close="closeCouponPopup"
  >
    <div class="coupon-popup-content">
      <h3 class="popup-title">{{ state.currentCard.name }}</h3>
      <div class="coupon-list">
        <div
          v-for="(item, index) in state.currentCard.couponList"
          :key="index"
          class="coupon-item"
        >
          <div class="coupon-bg">
            <div class="coupon-amount">
              <span class="amount-unit" v-if="item.type === 'coupon'">¥</span>
              <span class="amount-text">{{ item.money }}</span>
            </div>
            <div class="coupon-label">
              <span v-if="item.type === 'coupon'">无门槛</span>
              <span v-else>余额</span>
            </div>
            <div v-if="item.count > 1" class="coupon-count-badge">
              {{ item.count }}张
            </div>
          </div>
        </div>
      </div>

      <div class="coupon-price">
        <span class="unit">¥</span>
        <span class="price">{{ formatDecimal(state.currentCard.actual_amount)}}</span>
        <span class="jiazhi">价值¥{{ formatDecimal(state.currentCard.money)}}</span>
      </div>
      <div>

      <div class="coupon-tag">
        <div class="zhe" v-if="state.currentCard.discount_rules_text">
          <span class="tag-icon">折</span>
          <span class="van-ellipsis" >{{ state.currentCard.discount_rules_text }}</span>
        </div>

        <div class="special-tag" v-if="state.currentCard.tags">
          <img src="../../../assets/webActivity/couponPack/ico_time.png" alt="" class="tag-icon" />
          <span class="van-ellipsis" >{{ state.currentCard.tags }}</span>
        </div>

        <div v-if="state.currentCard.per_user_limit > 0" class="limit">每日限购{{state.currentCard.per_user_limit}}件</div>
      </div>


      <div :class="state.currentCard.purchase_status == 1 ? `coupon-buy-btn` : `coupon-buy-btn2`" @click.stop="handleBuy(state.currentCard)">
        {{ state.currentCard.purchase_status == 1 ? '立即抢购': state.currentCard.purchase_text }}
      </div>

      </div>

    </div>
  </van-popup>

  <!-- 支付弹框 -->
  <van-popup
    v-model:show="state.showPayPopup"
    round
    position="bottom"
  >
    <div class="pay-popup">
      <div class="pay-header">
        <img src="../../../assets/webActivity/couponPack/ico_bx.png" alt="" class="thumb" />
        <div class="title-price">
          <div class="title">{{ state.currentCard.name}}</div>
          <div class="price">¥{{ formatDecimal(state.currentCard.actual_amount || 0) }}</div>
        </div>
      </div>

      <div class="specs1">
        <div class="label" v-for="(item,index) in state.currentCard.couponList" :key="index">{{ item.name }}*{{ item.count }}</div>
      </div>

      <div class="specs">
        <div class="tags" v-if="state.currentCard.discount_rules_text">
          <span class="tag">多件优惠</span>
          <span class="rule">{{ state.currentCard.discount_rules_text }}</span>
        </div>
        <div class="limit" v-if="Number(state.currentCard.per_user_limit) > 0">
          每日限购{{ state.currentCard.per_user_limit }}件
        </div>
      </div>

      <div class="qty-row">
        <div class="price">
          <span class="unit">¥</span>
          <span class="amount">
            {{ formatDecimal(getActualTotalPrice()) }}
          </span>
          <span v-if="yhMoneyComputed > 0" class="yh">(已优惠¥{{ formatDecimal(yhMoneyComputed) }})</span>
        </div>
        <div class="qty-ctrl">
          <button class="btn" :disabled="state.payQuantity<=1" @click="decreaseQty">-</button>
          <span class="num">{{ state.payQuantity }}</span>
          <button
            class="btn"
            :disabled="Number(state.currentCard.purchase_num_oncelimit)>0 && state.payQuantity>=Number(state.currentCard.purchase_num_oncelimit)"
            @click="increaseQty"
          >+</button>
        </div>
      </div>

      <div class="pay-methods">
        <div class="title">
          支付方式
        </div>
        <div class="method" @click="selectPayMethod('alipay')">
          <div class="paytitle">
            <img src="../../../assets/webActivity/couponPack/ico_zfb.png" alt="">
            <span>支付宝</span>
          </div>

          <span class="img" :class="state.payMethod==='alipay' ? 'check' : ''"></span>
        </div>
        <div class="method" @click="selectPayMethod('wechat')">
          <div class="paytitle">
            <img src="../../../assets/webActivity/couponPack/ico_wx.png" alt="">
            <span>微信支付</span>
          </div>
          <span class="img" :class="state.payMethod==='wechat' ? 'check' : ''"></span>
        </div>
      </div>

      <div class="submit-row">
        <div class="submit" @click="onConfirmPay">确认支付¥{{ formatDecimal(getActualTotalPrice()) }}</div>
      </div>
    </div>
  </van-popup>

  <!-- 购买记录弹框 -->
  <van-popup
    v-model:show="state.showRecordPopup"
    position="center"
    round
    style="background-color: transparent;"
  >
    <div class="record-container">
      <div class="record-popup">
        <div class="record-title">购买记录</div>
        <div class="record-card">
          <van-pull-refresh v-model="state.recordRefreshing" @refresh="onRecordRefresh">
            <van-list
              v-model:loading="state.recordLoading"
              :finished="state.recordFinished"
              finished-text="没有更多了"
              @load="onRecordLoad"
            >
              <div v-for="(item, idx) in state.recordList" :key="idx" class="record-item">
                <div class="record-left">
                  <div class="row time">{{ item.created_at }}</div>
                  <div class="row">
                    <div class="name">券包：{{ item.activity_name }}</div>
                  </div>
                  <div class="row">
                    <div class="order">订单：{{ item.order_no }}</div>
                    
                  </div>
                  <!-- <div class="row qty">数量：x{{ item.buy_num }}</div> -->
                </div>
                <div class="record-right">
                  <div class="price">¥{{ formatDecimal(item.actual_amount) }}</div>
                  <div class="num">数量：{{ item.buy_num }}</div>
                </div>
              </div>
              
            </van-list>
          </van-pull-refresh>
        </div>
        <div class="record-empty"></div>
      </div>
      <div class="record-close" @click="closeRecordPopup"></div>
    </div>

  </van-popup>

  
</template>

<script setup>
import { onMounted, reactive, onUnmounted, ref, nextTick, computed, watch } from "vue";
import { getQueryString } from "@/utils/location";
import { setToken } from "@/utils/auth";
import { Toast } from "vant";
import { activityAlipay, activityOrderLog, activityWxpay, productLists, sessionlists } from "../../../api/activity";
import {
  detect,
  randomString
} from '@/utils/device';
const { getSessionSortValue, getSessionWindow } = require("./sessionTime");

const timeSlotsContainer = ref(null);
const timeSlotRefs = ref({});
const rulesSection = ref(null);

const state = reactive({
  showGame:false,
  showCouponPopup: false,
  showPayPopup: false,
  showRecordPopup: false,
  currentTimeSlot: 0, // 当前选中的时间段索引（12点场）
  timeSlots: [],
  couponCards: [],
  currentCard: {},
  payQuantity: 1,
  payMethod: 'alipay',
  isRequest: false,
  loading: false, // 加载状态
  // 购买记录
  recordList: [],
  recordPage: 1,
  recordTotalPage: 1,
  recordPageSize: 10,
  recordLoading: false,
  recordFinished: false,
  recordRefreshing: false,
});

// 计算总价（自动按discount_rules实时），使用大精度（如 Big.js）计算
import Big from "big.js";
import CouponPackSupportGamePopup from "../../public/CouponPackSupportGamePopup.vue";

const goRecord = ()=>{
  state.showRecordPopup = true;
  resetRecordList();
}

const closeRecordPopup = ()=>{
  state.showRecordPopup = false;
}

const goRule = ()=>{
  if (rulesSection.value) {
    rulesSection.value.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }
}

const resetRecordList = ()=>{
  state.recordList = [];
  state.recordPage = 1;
  state.recordFinished = false;
  state.recordLoading = false;
  loadRecords();
}

const onRecordLoad = ()=>{
  if (state.recordFinished || state.recordLoading) return;
  loadRecords();
}

const onRecordRefresh = ()=>{
  state.recordRefreshing = true;
  state.recordPage = 1;
  state.recordFinished = false;
  state.recordList = [];
  setTimeout(()=>{
    loadRecords();
  }, 300);
}

const loadRecords = ()=>{
  state.recordLoading = true;

  activityOrderLog({
    pagecode: state.recordPage,
    username: getQueryString('username'),
  }).then(response=>{
    if (response.data.code == 1) {
      state.recordTotalPage = response.data.data.total_page;
      state.recordList = state.recordList.concat(response.data.data.lists);

      if (state.recordPage >= state.recordTotalPage) {
        state.recordFinished = true;
      }

      state.recordPage = response.data.data.now_page;
      state.recordPage++;
    }
  }).finally(()=>{
    state.recordRefreshing = false;
  });
}

const getActualTotalPrice = () => {
  const q = Big(state.payQuantity || 0);
  const discountRules = state.currentCard.discount_rules || {};
  const actualAmount = Big(state.currentCard.actual_amount || 0);

  let pay = actualAmount.times(q);
  if (
    discountRules &&
    Object.keys(discountRules).length > 0
  ) {
    // 找到最大可用折扣
    const steps = Object.entries(discountRules)
      .map(([num, rate]) => ({ num: Number(num), rate: Number(rate) }))
      .sort((a, b) => a.num - b.num);
    let bestStep = null;
    for (let i = 0; i < steps.length; i++) {
      if (q.gte(steps[i].num)) bestStep = steps[i];
    }
    if (bestStep) {
      pay = actualAmount.times(q).times(Big(bestStep.rate));
    }
  }
  return Number(pay.toFixed(2));
};

// 计算优惠金额的计算属性（使用大精度计算，原价-总价方式）
const yhMoneyComputed = computed(() => {
  const q = Big(state.payQuantity || 0);
  const discountRules = state.currentCard.discount_rules || {};
  const actualAmount = Big(state.currentCard.actual_amount || 0);

  if (
    !discountRules ||
    typeof discountRules !== "object" ||
    Object.keys(discountRules).length === 0
  ) {
    return 0;
  }

  // 找到最大可用折扣
  const steps = Object.entries(discountRules)
    .map(([num, rate]) => ({ num: Number(num), rate: Number(rate) }))
    .sort((a, b) => a.num - b.num);
  let bestStep = null;
  for (let i = 0; i < steps.length; i++) {
    if (q.gte(steps[i].num)) bestStep = steps[i];
  }
  if (!bestStep) return 0;
  // 用大精度计算总原价和总现价之差
  const totalOrigin = actualAmount.times(q);
  const totalCurrent = (() => {
    if (bestStep) {
      return actualAmount.times(q).times(Big(bestStep.rate));
    }
    return totalOrigin;
  })();
  const diff = totalOrigin.minus(totalCurrent);
  return diff.gt(0) ? Number(diff.toFixed(2)) : 0;
});


let countdownTimer = null;

const BEIJING_OFFSET_MINUTES = 8 * 60;

const getBeijingNow = () => {
  const now = new Date();
  return new Date(
    now.getTime() + (BEIJING_OFFSET_MINUTES + now.getTimezoneOffset()) * 60 * 1000
  );
};

onMounted(() => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }

  sessionlists({ uid: getQueryString("uid"), token: getQueryString("token") }).then(res => {
    console.log(res.data);
    refreshTime(res.data)
  });

});

const formatDecimal = (num) => {
  // 双重解析确保输入安全
  const parsed = Number.parseFloat(num);
  
  // 智能零值检测系统
  return parsed % 1 === 0 
    ? parsed.toFixed(0)  // 整数模式
    : parsed.toString().replace(/(\.\d*?[1-9])0+$/, '$1'); // 小数模式
}

const refreshTime = (list)=>{

    const now = getBeijingNow();

    // 按时间先后排序
    const timeSlots = list.slice().sort((a, b) => {
      return getSessionSortValue(a.time) - getSessionSortValue(b.time);
    });

    // 找出当前活动场次
    let activeIndex = null;

    // 处理每个场次, 并根据当前时间设置status: 1=已开始, 2=未开始, 0=已结束
    timeSlots.forEach((slot, i) => {
      const { start, end } = getSessionWindow(timeSlots, i, now);

      console.log(start, end)

      if (now >= start && now < end) {
        // 活动已开始
        activeIndex = i;
        slot.status = 1;
        slot.isActive = true;
        // 倒计时到下一场
        let diff = Math.max(0, Math.floor((end - now) / 1000));
        let h = Math.floor(diff / 3600).toString().padStart(2, "0");
        let m = Math.floor((diff % 3600) / 60).toString().padStart(2, "0");
        let s = (diff % 60).toString().padStart(2, "0");
        slot.h = h;
        slot.m = m;
        slot.s = s;
        slot.countdown = `${h}:${m}:${s}`;
      } else if (now < start) {
        // 活动未开始
        slot.status = 2;
        slot.isActive = false;
        slot.h = "00";
        slot.m = "00";
        slot.s = "00";
        slot.countdown = "";
      } else {
        // 活动已结束
        slot.status = 0;
        slot.isActive = false;
        slot.h = "00";
        slot.m = "00";
        slot.s = "00";
        slot.countdown = "";
      }
    });

    if(timeSlots.length > 0){
      if(activeIndex == null){
        activeIndex = timeSlots.findIndex((slot, i) => now < getSessionWindow(timeSlots, i, now).start);
        if (activeIndex < 0) activeIndex = 0;
        timeSlots[activeIndex].isActive = true;
      }
      state.timeSlots = timeSlots;
      state.currentTimeSlot = activeIndex;


      // 开始倒计时
      startCountdown();
      // 初始化时滚动到当前选中的时间段
      nextTick(() => {
        scrollToTimeSlot(state.currentTimeSlot);
      });

      // 获取商品信息
      getList()
    }

}

const getList = ()=>{
  state.loading = true;
  productLists({ uid: getQueryString("uid"), token: getQueryString("token"),session_id: state.timeSlots[state.currentTimeSlot].id }).then(res=>{
    console.log(res.data)
    if(res.data.code == 1){
      var tempList = res.data.data.products
      // 先排序：按 actual_amount 升序
      tempList.sort((a, b) => Number(a.actual_amount) - Number(b.actual_amount));

      tempList.forEach(item =>{


        // 0 已结束 1 进行中 2 未开始
        var status = state.timeSlots[state.currentTimeSlot].status 
        if(status == 0){
          item.purchase_status = -1
          item.purchase_text = "已结束"
        }else if(status == 2){
          item.purchase_status = -1
          item.purchase_text = "未开始"
        }

        item.total_coupon_money = item.coupons
          .reduce((sum, coupon) => sum + (Number(coupon.coupon_money) || 0) * (Number(coupon.num) || 1), 0);

        // 新增字段，统计所有优惠券的总数量
        item.total_coupon_num = item.coupons
          .reduce((sum, coupon) => sum + (Number(coupon.num) || 0), 0);

        // 新增字段，限量则单次购买1个，非限量单次购买10个
        if(item.tags){
          item.purchase_num_oncelimit = 1
        }else{
          item.purchase_num_oncelimit = 10;
        }


        // discount_rules结构如：{"5":"0.98","10":"0.95"}
        // 判断非空对象
        if (
          item.discount_rules && 
          typeof item.discount_rules === 'object' && 
          Object.keys(item.discount_rules).length > 0
        ) {
          const rules = item.discount_rules;
          item.discount_rules_text = Object.entries(rules)
            .map(([count, discount]) => {
              // discount如0.98，显示为9.8折而不是98折
              let discountNum = Number(discount);
              let discountStr = (discountNum * 10) % 1 === 0
                ? (discountNum * 10).toFixed(0)
                : (discountNum * 10).toFixed(1);
              return `${count}件${discountStr}折`;
            })
            .join(' ');
        } else {
          item.discount_rules_text = "";
        }

        // 跟据coupons构建couponList
        const tempCouponList = []
        item.coupons.forEach(item2 => {
          tempCouponList.push({
            type: 'coupon',
            name: item2.name,
            money: formatDecimal(item2.coupon_money),
            count: item2.num,
          })
        })


        // 添加余额（如果有）
        if (item.give_money && Number(item.give_money) > 0) {
          tempCouponList.push({
            type: 'balance',
            name: formatDecimal(item.give_money) + '余额',
            money: formatDecimal(item.give_money),
            count: 1,
          });
        }
        item.couponList = tempCouponList;


      })

      state.couponCards = tempList
    } else {
      state.couponCards = []
    }
    state.loading = false;
  }).catch(err => {
    console.error(err);
    state.couponCards = [];
    state.loading = false;
  })
}

onUnmounted(() => {
  if (countdownTimer) {
    clearInterval(countdownTimer);
  }
});

// 滚动到指定时间段并居中
const scrollToTimeSlot = (index) => {
  if (!timeSlotsContainer.value || !timeSlotRefs.value[index]) {
    return;
  }
  
  const container = timeSlotsContainer.value;
  const targetElement = timeSlotRefs.value[index];
  
  // 计算需要滚动的距离（使目标元素居中）
  const containerWidth = container.offsetWidth;
  const targetWidth = targetElement.offsetWidth;
  const targetOffsetLeft = targetElement.offsetLeft;
  
  // 计算居中位置
  let scrollLeft = targetOffsetLeft - (containerWidth - targetWidth) / 2;
  
  // 边界处理：确保不会滚动超出范围
  const maxScrollLeft = container.scrollWidth - containerWidth;
  scrollLeft = Math.max(0, Math.min(scrollLeft, maxScrollLeft));
  
  // 平滑滚动
  container.scrollTo({
    left: scrollLeft,
    behavior: 'smooth'
  });
};

// 选择时间段
const selectTimeSlot = (index) => {
  state.couponCards = []
  state.currentTimeSlot = index;
  state.timeSlots.forEach((slot, i) => {
    slot.isActive = i === index;
  });
  // 滚动到选中的时间段并居中
  nextTick(() => {
    scrollToTimeSlot(index);
  });
  // 获取新场次的数据
  getList()
};

// 开始倒计时
const startCountdown = () => {
  countdownTimer = setInterval(() => {
    // const activeSlotList = state.timeSlots.filter((slot) => slot.status == 1);
    // activeSlotList.forEach(activeSlot => {
    //   if (activeSlot && activeSlot.countdown) {
    //   // 解析倒计时字符串 "09:22:40"
    //   const [hours, minutes, seconds] = activeSlot.countdown.split(":").map(Number);
    //   let totalSeconds = hours * 3600 + minutes * 60 + seconds;

    //   if (totalSeconds > 0) {
    //     totalSeconds--;
    //     const h = Math.floor(totalSeconds / 3600)
    //       .toString()
    //       .padStart(2, "0");
    //     const m = Math.floor((totalSeconds % 3600) / 60)
    //       .toString()
    //       .padStart(2, "0");
    //     const s = (totalSeconds % 60).toString().padStart(2, "0");
    //     activeSlot.h = h
    //     activeSlot.m = m
    //     activeSlot.s = s
    //     activeSlot.countdown = `${h}:${m}:${s}`;
    //   } else {
    //     // 倒计时结束，切换到下一个时间段
    //     activeSlot.status = 0;
    //     activeSlot.isActive = false;
    //     activeSlot.h = "00";
    //     activeSlot.m = "00";
    //     activeSlot.s = "00";
    //     activeSlot.countdown = "";
    //     // 这里可以添加切换到下一个时间段的逻辑

    //     clearInterval(countdownTimer);
    //     countdownTimer = null
    //     refreshTime(state.timeSlots)
    //   }
    // }
    // })





  const now = getBeijingNow();
    const selectedSlot = state.timeSlots[state.currentTimeSlot];
    const selectedWindow = getSessionWindow(state.timeSlots, state.currentTimeSlot, now);
    if ((selectedSlot.status == 1 && (now < selectedWindow.start || now >= selectedWindow.end))
      || (selectedSlot.status == 2 && now >= selectedWindow.start && now < selectedWindow.end)) {
      clearInterval(countdownTimer);
      countdownTimer = null;
      refreshTime(state.timeSlots);
      return;
    }

    // 处理每个场次, 并根据当前时间设置status: 1=已开始, 2=未开始, 0=已结束
    state.timeSlots.forEach((slot, i) => {
      if(slot.status == 1){
        const { end } = getSessionWindow(state.timeSlots, i, now);
          let diff = Math.max(0, Math.floor((end - now) / 1000));

          if(diff > 0){
            let h = Math.floor(diff / 3600).toString().padStart(2, "0");
            let m = Math.floor((diff % 3600) / 60).toString().padStart(2, "0");
            let s = (diff % 60).toString().padStart(2, "0");
            slot.h = h;
            slot.m = m;
            slot.s = s;
            slot.countdown = `${h}:${m}:${s}`;
          }else{
            // 倒计时结束，切换到下一个时间段
            slot.status = 0;
            slot.isActive = false;
            slot.h = "00";
            slot.m = "00";
            slot.s = "00";
            slot.countdown = "";
            // 这里可以添加切换到下一个时间段的逻辑

            clearInterval(countdownTimer);
            countdownTimer = null
            refreshTime(state.timeSlots)
          }


      }
      
    });

  }, 1000);
};

// 购买优惠券包
const handleBuy = (card) => {

  if(card.purchase_status == -1){
    Toast('活动' + card.purchase_text)
    return;
  }

  if(card.purchase_status == 0){
    Toast(card.purchase_text)
    return;
  }

  // 打开支付弹框
  state.currentCard = card;
  state.payQuantity = 1;
  state.payMethod = 'alipay';
  state.showCouponPopup = false;
  state.showPayPopup = true;
};

// 查看不可用游戏名单
const viewGameList = () => {
  state.showGame = true
};

// 显示优惠券弹框
const showCouponPopup = (card) => {
  state.currentCard = card;
  state.showCouponPopup = true;
};

// 关闭优惠券弹框
const closeCouponPopup = () => {
  state.showCouponPopup = false;
};

// 支付弹框相关
const increaseQty = () => {
  const limit = Number(state.currentCard.per_user_limit) || 0;
  if (limit > 0 && state.payQuantity >= limit) {
    Toast(`最多可购${limit}件`);
    return;
  }
  state.payQuantity++;
};

const decreaseQty = () => {
  if (state.payQuantity > 1) {
    state.payQuantity--;
  }
};

const selectPayMethod = (method) => {
  state.payMethod = method;
};

// 确认支付
const onConfirmPay = () => {
  console.log(state.currentCard)

  if(!getQueryString('username')){
    Toast("请先登录")
    return
  }

  if(state.isRequest){
    return
  }
  state.isRequest = true
  if(state.payMethod == 'alipay'){
    activityAlipay({
      product_id:state.currentCard.id,
      session_id:state.currentCard.session_id,
      buy_num:state.payQuantity,
      username:getQueryString('username'),
      order_no:'001_thb_zfb_'+randomString(5) + Date.now(),
    }).then(response=>{
      console.log(response)
      if(response.data.code == 1){
        if(document.getElementById('alipay')!=null){
          document.getElementById('alipay').parentNode.removeChild(document.getElementById('alipay'))
        }
        const div = document.createElement('div');
        div.id='alipay'
        div.innerHTML = response.data.data;
        console.log(div)
        document.body.appendChild(div);
        document.forms[0].submit();
      }else{
        Toast(response.data.msg)
      }
    }).finally(()=>{
      state.isRequest = false
    })
  }else{
    activityWxpay({
      product_id:state.currentCard.id,
      session_id:state.currentCard.session_id,
      buy_num:state.payQuantity,
      username:getQueryString('username'),
      order_no:'001_thb_wx_'+randomString(5) + Date.now(),
    }).then(response=>{
      console.log(response)
      if(response.data.code == 1){
        if (detect() == "android" || detect() == "harmony") {
          document.location.href = response.data.data;
        } else {
          window.parent.postMessage(
            { url: response.data.data, eventType: "wxPayH5" },
            "*"
          );
        }
        
      }else{
        Toast(response.data.msg)
      }
    }).finally(()=>{
      state.isRequest = false
    })
  }
  

};
</script>

<style src="../../../styles/removeVantcell.css"></style>
<style>
body {
  background: #FDB25F;
}
</style>
<style scoped>
/* :deep(.van-popup) {
  background-color: red;
} */
/* .record-container {
  background-color: transparent;
} */

.support-container {
  display: flex;
  align-items: center;
  height: 80px;
  margin-left: 32px;
  margin-right: 32px;
  background-color: #FFFBE5;
  border-radius: 100px;
  padding-left: 24px;
  padding-right: 24px;
  margin-top: 30px;
}

.support-container img {
  width: 28px;
  height: 28px;

}

.support-container span {
  font-size: 24px;
  color: #822813;
  margin: 0 8px;
  flex: 1;
}

.record-close{ 
  width: 64px; 
  height: 64px; 
  background-image:url('../../../assets/webActivity/couponPack/ico_record_close.png'); 
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 16px auto 0; 
}

.record-popup{ 
  position: relative; 
  width: 630px;
  height: 752px; 
  background-image:url('../../../assets/webActivity/couponPack/ico_record_bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
}
.record-card{ 
  flex: 1;
  position:relative; 
  margin: 0 auto; 
  width: 100%;
  border-radius: 24px; 
  padding: 20px 24px 0px;
  overflow-y: auto;
}
.record-empty{
  height: 36px;
}
.record-title{ 
  text-align:center; 
  font-size: 32px; 
  font-weight: bold; 
  margin-bottom: 8px;
  padding: 20px 24px 0px; 
}
.record-item{ 
  padding: 16px 4px; 
  border-bottom: 1px solid #f0f0f0; 
  display: flex;
  align-items: center;
}
.record-left{
  flex: 1;
  margin-right: 10px;
}
.record-right {
  display: flex;
  flex-direction: column;
  align-items: end;
  flex-shrink: 1;
}   
.record-right .num {
  color: #666;
  font-size: 22px;
  margin-top: 6px;
}
.record-item .row{ display:flex; justify-content: space-between; align-items:center; font-size:24px; color:#585858; }
.record-item .time{ color:#666; font-size:24px; margin-bottom:6px; }
.record-item .name{ color:#333; font-weight:600;font-size: 24px; }
.record-item .order{
  color: #666;
}
.record-item .status{ font-weight:600; }
.record-item .status.success{ color:#10c06f; }
.record-item .status.cancel{ color:#999; }
.record-item .price{ color:#ff4444; font-weight:bold; }
.record-item .qty{ color:#999; }



.content {
  height: 100vh;
  overflow: auto;
  background: #FDB25F;
}

.ico-record {
  position: absolute;
  top: 150px;
  right: 0px;
  z-index: 10;
  width: 64px;
  height: 262px;
  background-image: url('../../../assets/webActivity/couponPack/ico_record_i.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
}
.ico-record .rule{
  width: 100%;
  height: 100px;
}
.ico-record .record{
  flex: 1;
  width: 100%;
}
/* 顶部标题区域 */
.top-banner {
  width: 100%;
  position: relative;
}

.bg-top {
  width: 100%;
  display: block;
}

/* 时间段选择区域 */
.time-slots {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 32px;
  margin-top: -96px;
  gap: 12px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  /* 隐藏滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.time-slots::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.time-slot {
  flex: 0 0 auto;
  min-width: 180px;
  height: 132px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #333333;
  position: relative;
  transition: all 0.3s;
  cursor: pointer;
  white-space: nowrap;
  background-image: url('../../../assets/webActivity/couponPack/bg_uncheck.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-bottom: 20px;
}

.time-slot.active {
  background-image: url('../../../assets/webActivity/couponPack/bg_check.png');

}

.countdown {
  display: flex;
  flex-direction: column;
  font-size: 28px;
  text-align: center;
  color: #8e612699;
}
.countdown .lable {
  margin-top: 8px;
}
.countdown.active{
  color: #fff;
}

.time-icon {
  width: 32px;
  height: 32px;
}

.countdown .countdown-text {
  font-size: 22px;
  color: #fff;
  font-weight: bold;
}

.countdown .countdown-text .frame {
  height: 32px;
  border-radius: 6px;
  background-color: #8e612699;
  padding-left: 2px;
  padding-right: 2px;

}

.countdown .countdown-text .mao{
  color: #8e612699;
  font-weight: bolder;
  font-size: 32px;
  line-height: 32px;
  padding-left: 3px;
  padding-right: 3px;
}

.countdown.active .countdown-text {
  font-size: 22px;
  color: #F45B4B;
  font-weight: bold;
}

.countdown.active .countdown-text .frame {
  height: 32px;
  border-radius: 6px;
  background-color: #FFF7EA;
  padding-left: 2px;
  padding-right: 2px;

}

.countdown.active .countdown-text .mao{
  color: #FFFFFF;
  font-weight: bolder;
  font-size: 32px;
  line-height: 32px;
  padding-left: 3px;
  padding-right: 3px;
}


.time-label {
  display: flex;
  flex-direction: column;
  font-size: 28px;
  text-align: center;
  color: #8e612699;
}

.time-label span:first-of-type{
  font-size: 32px;
  font-weight: bold;
}

.time-label.active{
  color: white;
}


/* 优惠券卡片区域 */
.coupon-cards {
  padding: 0 30px 30px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 12px;
  min-height: 200px;
}

/* 加载容器 */
.loading-container {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 0;
  min-height: 250px;
}

/* 空状态容器 */
.empty-container {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  /* padding: 120px 0; */
  /* min-height: 300px; */
}

.empty-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-icon {
  width: 100%;
  margin-bottom: 24px;
}

.empty-text {
  font-size: 28px;
  color: #8E6126;
  text-align: center;
  font-weight: 500;
}

.coupon-card {
  position: relative;
  overflow: hidden;
}


.card-content {
  position: relative;
  padding: 20px;
  display: flex;
  border-radius: 40px;
  background: #fff;
  flex-direction: column;
  margin-top: 40px;
}

/* 补贴标签 */
.subsidy-tag {
  position: absolute;
  top: 20px;
  left: 4px;
  z-index: 1;
  background-image: url('../../../assets/webActivity/couponPack/ico_bt1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #ffffff;
  font-size: 20px;
  padding: 8px 18px 18px 16px;
  font-weight: bold;
  border-radius: 8px;
}

.subsidy-tag.xianliang{
  background-image: url('../../../assets/webActivity/couponPack/ico_bt2.png');
}

/* 优惠券信息 */
.coupon-info {
  width: 100%;
  height: 210px;
  background-image: url('../../../assets/webActivity/couponPack/bg_coupon.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.total-amount {
  height: 142px;
  font-weight: bold;
  color: #FF6666;
  display: flex;
  justify-content: center;
  align-items: center;
}
.total-amount .box {
  display: flex;
  align-items: baseline;

}
.total-amount .amount{
  font-size: 72px;
}

.coupon-count {
  font-size: 24px;
  color: #8E6126;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.arrow-icon {
  width: 20px;
  height: 20px;
}

/* 余额 */
.gift-balance {
  width: 100%;
  height: 56px;
  border: 2px solid #FFF1D5;
  background-color: #FFF7EA;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 22px;
  color: #FF6666;
  margin-top: 8px;
  cursor: pointer;
}

.coin-icon {
  width: 28px;
  height: 28px;
}

.tag-box{
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
  gap: 8px;
}



/* 特殊标签 */
.special-tag {
  display: flex;
  align-items: center;
  height: 36px;
  gap: 2px;
  background: #ff4444;
  color: #ffffff;
  font-size: 22px;
  padding: 0px 8px;
  border-radius: 8px;
  align-self: flex-start;
  overflow: hidden;
  max-width: 100%;
  max-lines: 1;
  margin-top: 6px;
}
.special-tag span {
  max-lines: 1;
}

.coupon-tag .special-tag {
  margin-top: 0;
  margin-right: 8px;
}
 .zhe {
  display: flex;
  align-items: center;
  height: 36px;
  font-size: 22px;
  border-radius: 8px;
  align-self: flex-start;
  overflow: hidden;
  max-width: 100%;
  max-lines: 1;
  margin-top: 6px;
  border: 2px solid #FE4D50;
  color: #FE4D50;
  background-color: white;
}
 .zhe img {
  height: 100%;
  width: 36px;
}
 .zhe span {
  padding-left: 14px;
  padding-right: 14px;
}

.tag-icon {
  width: 24px;
  height: 24px;
}
 .zhe {
  display: flex;
}
 .zhe .tag-icon {
  height: 100%;
  width: auto;
  background-color: #FE4D50;
  color: white;
  font-size: 22px;
}

.price-box{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}


/* 价格信息 */
.price-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}

.current-price {
  font-size: 40px;
  line-height: 56px;
  font-weight: bold;
  color: #ff4444;
}
.current-price span:first-of-type{
  font-size: 28px;
}

.original-price {
  font-size: 28px;
  color: #999999;
  text-decoration: line-through;
}

/* 购买按钮 */
.buy-btn {
  width: 132px;
  height: 72px;
  background: #111111;
  border-radius: 198px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  border: 2px solid #FF4A86;
}

.buy-btn2 {
  width: 132px;
  height: 72px;
  background: #D9D9D9;
  border-radius: 198px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
}

.buy-btn2 span {
  font-size: 24px;
  color: #999999;
  font-weight: bold;
}

.buy-btn:active {
  transform: scale(0.95);
  opacity: 0.8;
}

.buy-btn span {
  font-size: 24px;
  color: #F0FE69;
  font-weight: bold;
}

/* 底部规则说明区域 */
.rules-section {
  padding: 0 30px 40px;
}

.game-list-link {
  background: #fff8e1;
  border-radius: 100px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  color: #333333;
  cursor: pointer;
  height: 80px;
  padding: 0 24px;
  color: #822813;
}
.game-list-link span{
  flex: 1;
  
}

.tip-icon {
  width: 32px;
  height: 32px;
}

.rules-content {
  margin-top: 24px;
}

.rule-image {
  width: 100%;
  display: block;
}

/* 优惠券弹框样式 */
.coupon-popup-content {
  padding: 0 32px 74px;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(179.76deg, #fffbe5 0.21%, #ffffff 41.02%);
}

.popup-title {
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  color: #000000;
  margin: 20px 0;
}

.coupon-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-start;
  align-content: flex-start;
  padding-bottom: 20px;
}

.coupon-item {
  width: calc((100% - 40px) / 3);
  min-width: 0;
  flex-shrink: 0;
}

.coupon-bg {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  background-image: url('../../../assets/webActivity/couponPack/bg_coupon2.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 16px;
}

.coupon-amount {
  display: flex;
  align-items: baseline;
  justify-content: center;
  padding-top: 60px;
  color: #FF6666;
  font-weight: bold;
  flex: 1;
  width: 100%;
  
}

.coupon-amount .amount-text {
  font-size: 60px;
  line-height: 1;
  font-weight: bold;
}

.coupon-amount .amount-unit {
  font-size: 32px;
  margin-right: 4px;
}

.coupon-label {
  font-size: 22px;
  color: #8E6126;
  text-align: center;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 15px;
}

.coupon-count-badge {
  position: absolute;
  top: 16px;
  right: 20px;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  min-width: 68px;
  padding-left: 12px;
  padding-right: 12px;
  border-radius:  20px 20px 20px 0px;
  background: linear-gradient(270deg, #ff67ab 0%, #fe5f2c 100%);
}

.coupon-price {
  display: flex;
  align-items: baseline;
}

.coupon-price .unit {
  font-size: 28px;
  color: #FF6666;
  font-weight: bold;
}
.coupon-price .price {
  font-size: 40px;
  margin-right: 16px;
  color: #FF6666;
  font-weight: bold;
}
.coupon-price .jiazhi {
  font-size: 28px;
  color: #999999;
  line-height: 1.8;
}
.coupon-tag {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 12px;
}
.coupon-tag .zhe {
  margin: 0px;
  margin-right: 8px;
}
.coupon-tag .limit {
  font-size: 22px;
  height: 36px;
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #999999;
  color: #585858;
  border-radius: 6px;
}

.coupon-buy-btn {
  width: 100%;
  height: 108px;
  background: #111111;
  border-radius: 198px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  border: 2px solid #FF4A86;
  color: #fff;
  font-weight: bold;
  margin-top: 46px;
}

.coupon-buy-btn2 {
  width: 100%;
  height: 108px;
  background: #D9D9D9;
  border-radius: 198px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  color: #999999;
  font-weight: bold;
  margin-top: 46px;
}

/* ====== 支付弹框 ====== */
.pay-popup{
  padding: 32px 32px calc(32px + env(safe-area-inset-bottom));
  background: #fff;
}
.pay-header{
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 12px;
}
.pay-header .thumb{
  width: 140px;
  height: 140px;
  border-radius: 20px;
  background: #f5f5f5;
  object-fit: cover;

}
.pay-header .title-price{
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.pay-header .title{
  font-size: 32px;
  color: #000000;
}
.pay-header .price{
  font-size: 28px;
  color: #999999;
}

.specs,.specs1{
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}
.specs{
  margin-top: 14px;
}
.specs1 {
  margin-top: 20px;
}
.specs1 .label {
  font-size: 24px;
  color: #585858;
  height: 40px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #F4F4F4;
  border-radius: 6px;
}
.specs .tags{
  display: flex;
  align-items: center;
  border: 2px solid #FE4D50;
  overflow: hidden;
  border-radius: 8px;
}
.specs .tag{
  font-size: 22px;
  color: #fff;
  background: #ff5a54;
  padding: 2px 8px;
}
.specs .rule{
  font-size: 22px;
  color: #fe4d50;
  background: #fff;
  padding: 2px 10px;
}
.specs .limit{
  font-size: 22px;
  color: #585858;
  border-radius: 6px;
  border: 2px solid #999999;
  padding-left: 12px;
  padding-right: 12px;
}

.qty-row{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 28px 0;
  border-bottom: 1px solid #f2f2f2;
}

.qty-row .price {
  display: flex;
  align-items: baseline;
  letter-spacing: 1px;
}
.qty-row .price .unit {
  font-size: 28px;
  font-weight: bold;
  color: #FE5064;
}
.qty-row .price .amount {
  font-size: 40px;
  font-weight: bold;
  color: #FE5064;
}
.qty-row .price .yh {
  font-size: 28px;
  color: #FE5064;
  margin-left: 4px;
}

.qty-row > span{
  font-size: 28px;
  color: #111;
}
.qty-ctrl{
  display: inline-flex;
  align-items: center;
  gap: 16px;
}
.qty-ctrl .btn{
  width: 72px;
  height: 60px;
  border-radius: 12px;
  border: none;
  background: #f5f5f5;
  font-size: 32px;
  color: #111;
}
.qty-ctrl .btn:disabled{
  opacity: .5;
}
.qty-ctrl .num{
  min-width: 40px;
  text-align: center;
  font-size: 32px;
  color: #111;
}

.pay-methods{
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 20px 0 100px;
}

.pay-methods .title{
  color: #000000;
  font-size: 28px;
  font-weight: bold;
  margin-top: 8px;
  margin-bottom: 8px;
}

.pay-methods .method{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  padding: 0 32px;
  background: #F7F8FA;
  border-radius: 16px;
  font-size: 28px;
  color: #333;
}
.pay-methods .method .paytitle {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-weight: bold;
  gap: 20px;
}
.pay-methods .method img{
  width: 60px;
  height: 60px;
}
.pay-methods .method .img{
  width: 32px;
  height: 32px;
  background: url('../../../assets/webActivity/couponPack/ico_uncheck.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.pay-methods .img.check{
  background: url('../../../assets/webActivity/couponPack/ico_check.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.submit-row{
  position: sticky;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  background: #fff;
  padding-bottom: env(safe-area-inset-bottom);
}
.submit-row .amount{
  flex: 1;
  font-size: 36px;
  color: #ff4444;
  font-weight: bold;
}
.submit-row .submit{
  width: 100%;
  height: 100px;
  border-radius: 48px;
  background: #10d0bc;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 1px;
}

</style>
